import { useCallback, useEffect, useState } from 'react';
import api from '../api/client';

/**
 * Private Profile settings (placeholder phase).
 * Reads/persists the creator's desired configuration via
 * /api/me/private-profile-settings. Enforcement ships later
 * (`feature_live` flag in the response).
 */
export default function usePrivateProfileSettings() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/me/private-profile-settings');
      setSettings(data);
    } catch {
      setSettings(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const save = useCallback(async (patch) => {
    setSaving(true);
    try {
      const { data } = await api.put('/me/private-profile-settings', patch);
      setSettings(data);
      return { ok: true, data };
    } catch (err) {
      return { ok: false, error: err?.response?.data?.detail || 'error' };
    } finally {
      setSaving(false);
    }
  }, []);

  return { settings, loading, saving, save, reload: load };
}
